import React from 'react'
import { useStyle } from './SaasProducts.styles'
import { Typography } from '@mui/material'
import { AccordionComponent } from '@labrav/react-components'
import { getSaasProductSections } from '../AccordianSections/SaasProductsSection'
import milestonesAchievedImg from '../../../images/milestonesAchievedImg.jpg'

interface SaasProductsProps {
  partnerId: string
  setSaasProductsData: React.Dispatch<React.SetStateAction<unknown>>
  completedCount: number | string
  totalCount: number | string
  saasProductsMiestonesData: Record<string, boolean>
}

export const SaasProducts: React.FC<SaasProductsProps> = ({
  partnerId,
  setSaasProductsData,
  completedCount,
  totalCount,
  saasProductsMiestonesData,
}) => {
  const { classes } = useStyle()
  const sections = getSaasProductSections(
    classes,
    saasProductsMiestonesData,
    setSaasProductsData,
    partnerId
  )

  return (
    <>
      <div className={classes.root} data-testid="saas-product-container">
        {completedCount === 11 ? (
          <div
            className={classes.middleContainer}
            data-testid="saas-product-middle-container"
          >
            <img
              src={milestonesAchievedImg}
              alt="milestones-achieved-image"
              className={classes.completedImage}
            />
            <Typography className={classes.milestonesAchievedText}>
              Congratulations, you have achieved all milestones! 🥳
            </Typography>
          </div>
        ) : (
          <div
            className={classes.upperContainer}
            data-testid="saas-product-upper-container"
          >
            <div className={classes.leftContainer}>
              <Typography className={classes.headerText}>
                Complete all steps to gain maximum benefit from your cloud
                listing.
              </Typography>
            </div>
            <div className={classes.rightContainer}>
              <Typography className={classes.count}>
                {completedCount}
              </Typography>
              <Typography className={classes.totalCount}>
                /{totalCount}
              </Typography>
            </div>
          </div>
        )}
        <div
          className={classes.lowerContainer}
          data-testid="saas-product-lower-container"
        >
          <div className={classes.horizontalDivider}></div>
          <div className={classes.accordionComponent}>
            <AccordionComponent sections={sections} />
          </div>
        </div>
      </div>
    </>
  )
}
